import React from 'react';
import JBCard from '@jbhi-fi/lanyard-ui/components/Card';
import { palette } from '@jbhi-fi/lanyard-ui/themes';
import { styles } from './ContentBanner.css';
import { classNames } from '@jbhi-fi/lanyard-ui/global/utils';
import type { TermsAndConditionsData } from '../TermsAndConditions/TermsAndConditionsModal';
import { TermsAndConditionsLink } from '../TermsAndConditions/TermsAndConditionsLink';

export type ContentBannerProps = {
  coverImage: React.ReactNode;
  heading: string;
  content: string;
  topBorderColor?: string;
  ctaButton?: React.ReactNode;
  termsAndConditions?: TermsAndConditionsData;
};

export const ContentBanner = ({
  coverImage,
  heading,
  content,
  topBorderColor,
  ctaButton,
  termsAndConditions,
}: ContentBannerProps) => (
  <JBCard
    className={styles.card}
    contentClassName={styles.container}
    shadowColor={palette.primary.neutral}
    shadow={2}
    style={{
      borderTop: topBorderColor ? `6px solid ${topBorderColor}` : `6px solid ${palette.primary.main}`,
    }}
  >
    <div className={styles.coverContainer}>{coverImage}</div>
    <div className={styles.body}>
      <h2 className={classNames([styles.heading, styles.text])}>{heading}</h2>
      <p className={classNames([styles.content, styles.text])}>{content}</p>
      {ctaButton ? ctaButton : null}
    </div>
    {termsAndConditions ? (
      <div className={styles.termsLinkContainer({ isWhiteLink: termsAndConditions?.linkColor === 'white' })}>
        <TermsAndConditionsLink termsAndConditions={termsAndConditions} />
      </div>
    ) : null}
  </JBCard>
);
